module.exports = __webpack_public_path__ + "media/hk_video_intro.476b8c6f.ogg";